(function() {
'use strict';

angular
    .module('TR')
    .service('destinationContent', destinationContent);

function destinationContent($http, pageStrand, objectTypeService, fidParser) {
    const url = '/api2/destination/content?';
    const service = {
        get
    };

    function get(destination) {
        const { Type, Id } = objectTypeService.getObjectTypeAndId(destination);
        return $http.get(url + $.param({
            Id,
            Type,
            FilterId: fidParser.parse() || 0,
            DomainId: TRPCONFIG.Domain.DomainId,
            ApplicationType: TRPCONFIG.ApplicationType,
            TenantId: TRPCONFIG.Domain.TenantId,
            CultureCode: TRPCONFIG.Domain.CultureCode,
            PageStrand: pageStrand.fromRoute(destination)
        }), { cache: true, ignoreErrors: true }).then(function(res) {
            return res.data.Contents;
        });
    }

    return service;
}
})();
